import {
  Button,
  ButtonGroup,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { useMaterialUIController } from "context";
import { useState } from "react";
import getText from "Translator";

let clearError = false;
export default function TextComponent(props) {
  const {
    question,
    disabled,
    editQuestionHandle,
    helpPage,
    headline,
    setFocuse,
  } = props;
  const [error, setError] = useState(false);
  const [val, setVal] = useState(question.useranswer);
  const [controller, dispatch] = useMaterialUIController();
  const renderAllowCopy = () => {
    return (
      <CachedIcon
        onClick={async () => {
          if (question.useranswer == question.copyValue) {
            editQuestionHandle(question, "");
          } else {
            editQuestionHandle(question, question.copyValue);
          }
        }}
        style={{
          color: "#039dfc",
          height: 20,
          width: 25,
          marginTop: -50,
          marginInlineEnd: -20,
          cursor: "pointer",
          zIndex: 999,
        }}
      />
    );
  };
  return (
    <Grid
      item
      xs={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      sm={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      md={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      style={{
        position: question.fixTop || question.fixBottom ? "fixed" : "unset",
        left: question.fixTop || question.fixBottom ? 0 : "unset",
        right: question.fixTop || question.fixBottom ? 0 : "unset",
        top: question.fixTop ? 0 : "unset",
        bottom: question.fixBottom ? 0 : "unset",
        paddingBottom: question.fixTop || question.fixBottom ? 10 : "unset",
        backgroundColor:
          question.fixTop || question.fixBottom ? "#FFF" : "unset",
        zIndex: question.fixTop || question.fixBottom ? 999 : "unset",
        paddingTop: question.fixTop ? 55 : question.fixBottom ? 10 : "unset",
        paddingBottom: question.fixBottom ? 55 : question.fixTop ? 10 : "unset",
        paddingRight: question.fixTop || question.fixBottom ? 15 : "unset",
        paddingLeft: question.fixTop || question.fixBottom ? 15 : "unset",

        marginTop:
          question.titleType === 2 ? 8 : question.displayTitle ? 5 : 8,
        marginBottom: question.helpPage ? -15 : 0,
        display: question.visible ? "" : "none",
      }}
    >
      {question.displayTitle && question.titleType === 1 && (
        <b>{question.text}</b>
      )}

      <TextField
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        label={
          question.displayTitle && question.titleType === 2 ? question.text : ""
        }
        disabled={disabled}
        style={{
          width: "100%",
          backgroundColor:
            error || (!clearError && question.error) ? "#f3bab6" : "inherit",
        }}
        id={question.questionId}
        fullWidth={true}
        value={val}
        placeholder={question.tooltip}
        onBlur={(event) => {
          clearError = true;
          editQuestionHandle(question, event.target.value);
        }}
        onChange={(event) => {
          setVal(event.target.value);
        }}
        onSelect={() => {
          setFocuse(question.code);
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment>{question.startText + ""}</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {question.allowCopy &&
                question.copyValue &&
                renderAllowCopy(props)}
            </InputAdornment>
          ),
        }}
      />
      {question.helpPage && (
        <Button
          style={{
            marginTop: -10,
          }}
          onClick={() => {
            helpPage(question.helpPage);
          }}
          className="helplink"
          fullWidth={true}
        >
          <div
            style={{
              width: "100%",
              fontSize: 11,
              textAlign: "fa" == "fa" ? "left" : "right",
            }}
          >
            {question.helpText === ""
              ? getText("helptext", "fa")
              : question.helpText}
          </div>
        </Button>
      )}
    </Grid>
  );
}
